import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../common-service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormatService } from '../format.service';
import { SanitizationService } from '../sanitization.service';
import { SafeHtml } from '@angular/platform-browser';
import { last } from 'rxjs';
import { format } from 'sql-formatter';
interface Control {
  label: string;
  type: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  default?: any;
  conditional?: {
    field: string;
    value: any;
  };
}

interface DatabaseControls {
  [key: string]: { controls: Control[] };
}
@Component({
  selector: 'app-datainsight',
  templateUrl: './datainsight.component.html',
  styleUrl: './datainsight.component.scss'
})
export class DatainsightComponent implements OnInit {
  controls: any[] = [];
  dbControls:any[]=[];
  connectionForm: FormGroup = this.fb.group({});
  selectedDatabase: string = '';
  conversationDetails:any[]=[];
  filteredConversations:any[] = [...this.conversationDetails];
  groupedConversations: { [key: string]: any[] } = {};
  reversedConversations: { [date: string]: any[] } = {}; 
  showConv: boolean=false;
  selectedConversationId: any;
  objectKeys = Object;
  connection_Id: any;
  prevConvesations: any[]=[];
  loader: boolean=false;
  database_name: any;
  isQnCopied: { [key: number]: boolean } = {};
  Conv_Name: any;
  AnswerArray: any[]=[];
  query: any;
  tableSchema: any;
  inputHeight: number = 40;
  @ViewChild('scrollMe') myScrollContainer!: ElementRef;
  Delete_payload: any;
  displayDeletemodal: boolean=false;
  deleteMessage: string='';
  selectedDbType:any;
  conn_visible: boolean=false;
  skipDbChange: boolean=false;
  newConvId: any;
  formReady: boolean=false;
  activeTab:any;
  activeApiCalls: number=0;
  modalloader: boolean= false;
  showprompt: boolean= false;
  selectedConversation: any
  isSaveEnabled: boolean= false;
  sqlFormatter: any;
  constructor(private api: CommonService,private messageService: MessageService,private sanitizeService:SanitizationService, private http: HttpClient,
    private readonly changeDetectorRef: ChangeDetectorRef,private fb: FormBuilder, private formatService: FormatService
  ){

    this.editForm = this.fb.group({
        content: ['']
      });
  }
  selectedCollection: any
  token:any
  showtextbox = false
  searchcollection: any = ''
  language: any='';
  searchcontainer: any = true
  suggestions: any
  errorMessage = false
  timer = false
  question:any = '';
  displayedData: any = '';
  cannedId!: any;
  cannedanswer: boolean=false;
  questionId: any;
  answersArray: any = []
  isCopied: { [key: number]: boolean } = {};
  databrickInstances = [];
  selectedInstance:any='';
  setconv_name: boolean=false;
  visible=false
  searchQuery: string = '';
  connectionName:string='';
  showconnections:boolean=false;
  errorType: any;
  retryContext:any ;
  showconnectionName=false
  showError: boolean=false;
  paginatedConversations: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  isUserScrolling: boolean=false;
  shouldScrollToBottom = true;
  editForm: FormGroup;

  ngOnInit(): void {
    this.getAllConversations();
    this.fetchConnections();
    // this.getDbControls();
    const contentControl = this.editForm.get('content');
    contentControl?.valueChanges.subscribe(value => {
      // this.isSaveEnabled = value && value.trim().length > 0;
        this.isSaveEnabled = contentControl.dirty;
    });
  }

  fetchConnections(){
    this.api.getpMethod('allConnections').subscribe({
      next:(res)=>{
        this.databrickInstances=res.databricks_connections;
        },
        error:(error) => {
          console.error('API Error:', error);
          this.messageService.add({ severity: 'error', detail: error.error.message});}
  })
  }

  onInstanceSelect(e:any){
    this.connection_Id=e.conn_id;
    let payload=
    {
      "connection_id": e.conn_id,
      "connection_name": e.connection_name
    }
  this.api.postpMethod('selectConnection',payload).subscribe({
    next:(res)=>{
      this.showconnectionName = true
      this.setconv_name=true;
      this.connectionName ='';
      this.showconnections=false;
      },
      error:(error) => {
        this.errorType='connection';
        this.retryContext={e};
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.ex_error_description});}
  })
  }
  onScroll(): void {
    const container = this.myScrollContainer.nativeElement;
    const threshold = 5; 
    const position = container.scrollHeight - container.scrollTop - container.clientHeight;
    this.isUserScrolling = position > threshold;
  }
  showConectionmodal(){
    this.conn_visible=true;  
    this.fetchConnections();
    
  }
  startConversation() {
    if(!this.connectionName){
      this.showError=true;
    }else{
      this.showError=false;
    let payload={
      "conn_id": this.connection_Id,
      "conv_name": this.connectionName
  }
    this.api.postpMethod("newConversation",payload).subscribe({
      next:(res)=>{
        this.setconv_name=false;
        this.conn_visible=false;
        this.newConvId=res.conversation_id;
        this.messageService.add({ severity: 'success', detail: `${this.connectionName} conversation created successfully` });
        this.getAllConversations()
        },
        error:(error) => {
          console.error('API Error:', error);
          this.messageService.add({ severity: 'error', detail: error.error.ex_error_description});
        }
  })
}
  }

  shownewconnectionmodal() {
    this.formReady = true;

    this.getDbControls();
    this.connectionForm = this.fb.group({
      connection_name: ['', Validators.required],
      db_type: ['', Validators.required],
      host: ['', Validators.required],
      port: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      database_name: ['', Validators.required],
    });
  
    this.controls = [];    
    this.visible = true;  // Show the modal
  }
  
  onDialogHide(){
    this.visible=false;
    this.connectionForm.reset(); 
    this.formReady = false;
 
  }
  getDbControls(){
    this.api.getpMethod(`db-controls`).subscribe(
      (res) => {
        if (res.error === '0') {
          this.dbControls = res.db_controls;
        }
  });
  }
  onDatabaseChange(event: Event): void {
    this.resetForm();
    const dbType = (event.target as HTMLSelectElement).value;
    const selectedDb = this.dbControls.find((db:any) => db.db_type === dbType);
    
    if (selectedDb) {
      this.controls = selectedDb.controls;
  
      const formGroup: any = {
        db_type: new FormControl(dbType, Validators.required),
        connection_name: new FormControl('', Validators.required)
      };
      this.controls.forEach(control => {
        const validators = [];
        if (control.required) validators.push(Validators.required);
        formGroup[control.name] = new FormControl(control.default || '', validators);
      });
  
      this.connectionForm = this.fb.group(formGroup);
      this.applyConditionals();
    } else {
      this.controls = [];
      this.connectionForm.reset();
    }
  }
  applyConditionals() {
  this.controls.forEach(control => {
    if (control.conditional) {
      const conditionField = control.conditional.field;
      const expectedValue = control.conditional.value;

      const shouldEnable = this.connectionForm.get(conditionField)?.value === expectedValue;

      const fieldControl = this.connectionForm.get(control.name);
      if (shouldEnable) {
        fieldControl?.enable();
      } else {
        fieldControl?.disable();
      }
    }
  });
}
resetForm() {
  this.connectionForm.reset();
}

onSubmit() {
  if (this.connectionForm.invalid) return;
  const payload = this.connectionForm.value;

  this.api.postpMethod('saveConnection', payload, ).subscribe({
    next: (response) => {
      this.messageService.add({ severity: 'success', detail: "connection is created successfully"}); 
      this.visible=false;  
      this.conn_visible=true;  
      this.fetchConnections();
    },
    error: (error) => {
      console.error('Error saving connection:', error);
      this.messageService.add({ severity: 'error', detail: error.error.ex_error_description}); 
    }
  });
}

  private formatTimestamp(timestamp: string): string {
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');
    const conversationDate = moment(timestamp);
  
    if (conversationDate.isSame(today, 'day')) {
      return 'Today';
    } else if (conversationDate.isSame(yesterday, 'day')) {
      return 'Yesterday';
    } else {
      return conversationDate.format('MMMM D, YYYY'); 
    }
}

// Utility function to group conversations by date
groupConversationsByDate(conversations: any[]): { [key: string]: any[] }  {
  return conversations.reduce((acc, conversation) => {
    const dateKey = this.formatTimestamp(conversation.timestamp);
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(conversation);
    return acc;
  }, {}); 
}

compareKeys(a: { key: string }, b: { key: string }): number {
  if (a.key === 'Today') return -1;
  if (b.key === 'Today') return 1;
  if (a.key === 'Yesterday') return -1;
  if (b.key === 'Yesterday') return 1;

  // For other dates, parse and compare
  const dateA = new Date(a.key).getTime();
  const dateB = new Date(b.key).getTime();

  return dateB - dateA; // Descending order
}

onHidedefaultPrompt(){
    // this.selectedConversation.custom_prompt
    this.editForm.markAsPristine();
    this.isSaveEnabled= false
}

sanitizePromptMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }

saveChanges() {
    const updatedContent = this.editForm.value.content;

    if(this.selectedConversation.custom_prompt && updatedContent.trim() == this.selectedConversation.custom_prompt.trim()){
      this.messageService.add({ 
      severity: 'info', 
      detail: 'No changes detected in the content' 
      });
    }else{
      let payload = {
        "custom_prompt": updatedContent,
        "cov_id": this.selectedConversation.conversation_id
      }
      this.modalloader=true
      this.api.postpMethod('updateConversationCustomPrompt', payload).subscribe( {
        next: (response: any) => {
          this.editForm.get('content')?.patchValue(updatedContent)
          this.showprompt=false
          this.modalloader=false
          this.onHidedefaultPrompt();
          this.messageService.add({ severity: 'success', detail: response.ex_error_description});
          this.getAllConversations()
          
          
      },
      error: (error: any) => {
          console.error('Error updating document', error);
          this.messageService.add({ severity: 'error', detail: error.error.ex_error_description});
          this.showprompt=false
          this.modalloader=false          
          this.onHidedefaultPrompt();
      }
    });      
    }
  }

  closePrompt(){
    this.showprompt=false
    this.isSaveEnabled= false
  }

selectUserPrompt(conversation: any, event:Event){
    event.stopPropagation()
    this.selectedConversation = conversation; 
    this.showprompt = true;
    this.editForm.patchValue({
        content: conversation.custom_prompt
      });
    this.modalloader = false;
}

selectConversation(conversation: any, isAutoSelect: boolean) {
  this.showConv=false;
  this.Conv_Name=conversation.conv_name;
  this.AnswerArray=[];
  if (conversation.conversation_id !== this.selectedConversationId) {
    this.selectedConversationId = conversation.conversation_id;
    localStorage.setItem('selectedConversationId', this.selectedConversationId);
    this.loadTableschema(this.selectedConversationId)
  }
}
  getAllConversations() {   
    this.api.getpMethod('allConversations').subscribe({
      next: (res) => {
        const conversationsWithDates = res.conversations.map((conv:any) => {
          return {
            ...conv,
            displayTimestamp: this.formatTimestamp(conv.timestamp),
          };
        });
        this.filteredConversations = [...this.conversationDetails];
        this.conversationDetails=res.conversations;

        // Group conversations by date
        this.groupedConversations = this.groupConversationsByDate(conversationsWithDates);
        const groupedKeys = Object.keys(this.groupedConversations);       
        
          const reorderedGroupedConversations = groupedKeys
          .sort((a, b) => this.compareKeys({ key: a }, { key: b }))
          .reduce((acc, dateKey) => {
            acc[dateKey] = this.groupedConversations[dateKey].sort(
              (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
            );
            return acc;
          }, {} as { [key: string]: any[] });
      this.reversedConversations = JSON.parse(JSON.stringify(reorderedGroupedConversations));
        const selectedConversationId = localStorage.getItem('selectedConversationId');
        const defaultConversation = this.conversationDetails.find(conv => conv.isDefault == 1);
        if(this.newConvId){
         const defaultconv=this.conversationDetails.find(conv => conv.conversation_id == this.newConvId);
        this.selectConversation(defaultconv, true);
        }
      else if (defaultConversation) {
        this.selectConversation(defaultConversation, true);
      } else if (this.conversationDetails.length > 0) {
          this.selectConversation(this.conversationDetails[0], true);
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.message });
      }
    });
  }


  searchConversation() {
    if (this.searchQuery.trim()) {
      const filtered = this.conversationDetails.filter(conv =>
        conv.conv_name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      this.filteredConversations = filtered;
      this.reversedConversations = this.groupConversationsByDate(filtered);
      console.log(this.reversedConversations);
    } else {
      this.filteredConversations = [...this.conversationDetails];
      this.reversedConversations = this.groupConversationsByDate(this.conversationDetails);      
    }
  }
  getConversationById(id: any) {
    this.prevConvesations = [];
    this.loader = true;
    this.api.getpMethod(`allConversationsAndStataCodesByConversationID?conversation_id=${id}`).subscribe({
      next: (res) => {
        this.database_name = res.connection_name;

        if (res.conversations) {
          // Map and process conversations
          this.prevConvesations = res.conversations.map((conversation: any) => {
            let parsedData = [];
            let headers: string[] = [];
            let description = conversation.dataset_description;
            let conversation_id = id
            try {
              if (conversation.dataset && conversation.dataset.length > 0) {
                parsedData = conversation.dataset;
                if (Array.isArray(parsedData[0])) {
                  headers = Array.from({ length: parsedData[0].length }, (_, i) => `Column ${i + 1}`);
                } else if (typeof parsedData[0] === 'object') {
                  headers = Object.keys(parsedData[0]);
                  parsedData = parsedData.map((row: any) => Object.values(row));
                }
              } else {
                // Handle empty dataset
                description = "No records found for the given query";
                headers = [];
                parsedData = [];
              }
            } catch (e) {
              // Handle any parsing errors gracefully
              description = "An error occurred while processing the dataset.";
              headers = [];
              parsedData = [];
            } return {
              ...conversation, chart_data: conversation.chart_data, analysis: conversation.analysis, parsedData, headers, conversation_id, dataset_description: description, currentPage: 1,
              paginatedData: [], totalPages: Math.ceil(parsedData.length / this.pageSize), activeTab: 'table', chartLoading: false,        // for loader
              analysisLoading: false, chartFetched: false, analysisFetched: false, hasValidChart: null, hasAnalysis: null
            };
          });
          this.prevConvesations.forEach((conversation) =>
            this.updatePaginatedData(conversation));
        }
        this.loader = false;
      },
      error: (error) => {
        this.loader = false;
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.ex_error_description });
      }
    });
  }

  refreshChart(conversation: any) {
  conversation.chartFetched = false;
  conversation.chartLoading = true;
  this.fetchVisualizationData(conversation);
  }

  refreshAnalysis(conversation: any) {
    conversation.analysisFetched = false;
    conversation.analysisLoading = true;
    this.fetchSmartAnalysis(conversation);
  }

  fetchVisualizationData(conversation: any) {    
        const payload = {
          query: conversation.question,
          dataset: conversation.dataset ? conversation.dataset : conversation.tableData,
          conversation_id: conversation.conversation_id,
          conv_detail_id: conversation.conv_detail_id,
          sql_query: conversation.response_sql
        };
          this.api.postpMethod('queryVisualisation', payload).subscribe({
               next: (res) => {
            if (res.error === "0") {
              conversation.chartData = this.sanitizeChartData(res.chart_data);
               conversation.hasValidChart=true;
             } else {
            conversation.hasValidChart=false;
            conversation.chartData = null;            
            console.error('Visualization API error:', res.ex_error_description);
            }      
             conversation.chartLoading = false;
              conversation.chartFetched = true;
               },
           error: (error) => {
           conversation.hasValidChart=false;
           conversation.chartData = null;
            conversation.chartLoading = false;
            conversation.chartFetched = false;
            console.error('Visualization API call failed:', error);
           }
          });
      }

      private sanitizeChartData(chartData: any) {
        if (!chartData || !chartData.options) return chartData;

        // remove tooltip callbacks to avoid errors
        if (chartData.options.plugins?.tooltip?.callbacks) {
          delete chartData.options.plugins.tooltip.callbacks;
        }

        return chartData;
      }
     

      fetchSmartAnalysis(conversation: any) {        
        const payload = {
          query: conversation.question,
          dataset: conversation.dataset ? conversation.dataset : conversation.tableData,
          conversation_id: conversation.conversation_id,
          conv_detail_id: conversation.conv_detail_id,
          sql_query: conversation.response_sql
        };
        this.api.postpMethod('querySmartAnalysis',payload).subscribe({
          next: (res) => {
            if (res.error === "0") {
              conversation.smartAnalysis = res.analysis;
              conversation.hasAnalysis=true;
            } else {
              conversation.hasAnalysis=false;
              conversation.smartAnalysis ='';
              console.error('Smart Analysis API error:', res.ex_error_description);
            }
            conversation.analysisLoading = false;
            conversation.analysisFetched = true;
          },
          error: (error) => {
            conversation.hasAnalysis=false;
            conversation.analysisLoading = false;
            conversation.analysisFetched = false;
            conversation.smartAnalysis = ["Smart analysis fetch failed."];
            console.error('Smart Analysis API call failed:', error);
          }
        });
      }
      onDataTabClick(data: any, tab: string) {
        data.activeTab = tab;

        if (tab === 'chart' && !data.chartFetched ) {
          data.chartLoading = true;
          this.fetchVisualizationData(data);
        }

        if (tab === 'smart' && !data.analysisFetched) {
          data.analysisLoading = true;
          this.fetchSmartAnalysis(data);
        }
      }

  updatePaginatedData(conversation: any) {
    const start = (conversation.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    // Slice the parsed data to get the data for the current page
    conversation.paginatedData = conversation.parsedData.slice(start, end);
  }
   sanitizeMessage(message: string,searchText:any): SafeHtml {
      return this.sanitizeService.sanitizeMessage(message,searchText);
     }
  copyToClipboard(data:any,index:number) {
    let contentToCopy = '';
    if (typeof data === 'string') {
      contentToCopy = data;
    } else {
      let source;
  
      if (Array.isArray(data)) {
        source = data; // Case: Array of objects
      } else if (data.dataset) {
        source = data.dataset; // Case: `dataset` in the object
      } else if (data.tableData) {
        source = data.tableData; // Case: `tableData` in the object
      }
  
      if (source && source.length > 0) {
        const headers = data.displayedColumns || Object.keys(source[0]);
        const rows = source.map((item:any) => headers.map((header:any) => item[header] || "").join('\t'));
        contentToCopy = [headers.join('\t'), ...rows].join('\n');
      } else {
        console.error("No valid data found to copy.");
        return;
      }
    }
  
    navigator.clipboard.writeText(contentToCopy)
    .then(() => {
      console.log("Content copied to clipboard!");
      this.isCopied[index] = true;
      setTimeout(() => {
        this.isCopied[index] = false;
        this.changeDetectorRef.detectChanges();
      }, 2000);
    })
    .catch((err) => {
      console.error("Failed to copy content:", err);
    });
  
  }
  downloadprevAnswer(conversation: any,dataset_name:any): void {
    if (!conversation) {
      console.error('No conversation data available.');
    }
    
  let content='';
    if (conversation.headers && conversation.parsedData) {
      content += conversation.headers.join(',') + '\n'; 
      content += conversation.parsedData
        .map((row: any) =>row.map((cell: any) => this.stripHtmlTags(cell)) // Sanitize each cell
        .join(',')
     ) 
        .join('\n'); // Separate rows by newlines
    } else {
      content += `Dataset: No data available.\n`;
    }
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${dataset_name || 'dataset'}.csv`; // File name
    a.click();
    URL.revokeObjectURL(url); // Clean up
  }
   // Handle page change for a specific conversation
   changePage(conversation: any, direction: string) {
    if (direction === 'prev' && conversation.currentPage > 1) {
      conversation.currentPage--;
    } else if (direction === 'next' && conversation.currentPage < conversation.totalPages) {
      conversation.currentPage++;
    }
    this.updatePaginatedData(conversation);
  } 
  
  stripHtmlTags(input: string): string {
    const div = document.createElement('div');
    div.innerHTML = input;
    return div.textContent || div.innerText || '';
  } 
  
    copyQnToclipboard(data: any, index: number): void {
      const contentToCopy = data;
      navigator.clipboard.writeText(contentToCopy)
        .then(() => {
          console.log("Content copied to clipboard!");
          this.isQnCopied[index] = true;
          setTimeout(() => {
            this.isQnCopied[index] = false;
            this.changeDetectorRef.detectChanges(); 
          }, 2000);
        })
        .catch(err => {
          console.error("Failed to copy content:", err);
        });
    }
    
    adjustInputWidth(event: Event): void {
      const target = event.target as HTMLTextAreaElement;
      target.style.height = 'auto';
      this.inputHeight = target.scrollHeight
    }
    formatData( value: string | number) {
      return this.formatService.formatText( value);
    }
    ngAfterViewChecked() {
      if (!this.isUserScrolling && this.shouldScrollToBottom) {
        this.scrollToBottom();
      }      
    }
    scrollToBottom(): void {
      try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        this.changeDetectorRef.markForCheck();
      } catch (err) { }
    }
    onEnterPress(event: any): void {
      event.preventDefault(); // Prevents default action (e.g., form submission)
        this.askQuery();
      }
      askQuery() {
        this.isUserScrolling=false;
        this.shouldScrollToBottom = true;
        this.errorMessage=false;
        const trimmedQuery = this.query.trim();
        this.AnswerArray = this.AnswerArray.filter((item) => item.sqlDescription !== 'Error loading response.');
        if (!trimmedQuery) {
          return;
        }
        // this.displayAnswer=true;
        this.showtextbox=true;
        
      const newAnswer = {
        type:"queryAnswer",
        question: trimmedQuery,
        isLoading: true, // Indicates that the answer is being generated
        sqlDescription: '',
        displayedColumns: [],
        tableData: [],
        row_count: 0,
        pagination: {
                currentPage: 1,
               itemsPerPage: 10, // Default items per page
                
             },
             chartLoading: false,
        analysisLoading: false,
        chartFetched: false,
        analysisFetched: false,
        hasValidChart: null,
        hasAnalysis: null,   
        displaySQLmodal:false,
        sql_query:'',
        conv_detail_id:0
      };
      this.AnswerArray = [...this.AnswerArray, {...newAnswer}];
    
      // API Payload
      const payload = {
        query: trimmedQuery,
        conversation_id: this.selectedConversationId,
        table_name_n_table_schema_dict: this.tableSchema
      };
      const index = this.AnswerArray.length - 1;
            let lastobj=this.AnswerArray[index];
    
      this.api.postpMethod('queryToSQL', payload).subscribe({
        next: (res) => {
          if (res.error == '0') {        
            if (res.dataset && res.dataset.length > 0) {
              lastobj.sqlDescription = res.dataset_description;
              lastobj.displayedColumns = Object.keys(res.dataset[0]);
              lastobj.tableData = res.dataset;
              lastobj.sql_query=res.sql_query;
              lastobj.response_sql= res.response_sql;
              lastobj.conv_detail_id=res.conv_detail_id;
              lastobj.displaySQLmodal=false;
            } else {
              lastobj.sqlDescription = "No records found for the given query.";
              lastobj.displayedColumns = [];
              lastobj.tableData = [];
            }
             lastobj.row_count= res.num_of_records || 0,
              lastobj.conv_detail_id= res.conv_detail_id;
              lastobj.pagination.totalPages = Math.ceil((res.num_of_records || 0)/ lastobj.pagination.itemsPerPage);
               lastobj.pagination.currentPage = 1;
               lastobj.activeTab='table';
            this.AnswerArray[index] = lastobj;
            this.showtextbox=false;
            lastobj.conversation_id=this.selectedConversationId;
            lastobj.isLoading=false; 

          } else if (res.error == '1') {
                    // this.handleError(index, 'Error loading response.');
                    lastobj.question=trimmedQuery;
                     lastobj.isLoading = false;
                    lastobj.sqlDescription = res.ex_error_description;
                   lastobj.displayedColumns = [];
                    lastobj.tableData = [];
                   lastobj.row_count = 0;
                   lastobj.pagination.totalPages =0
               lastobj.pagination.currentPage = 1;
                    this.AnswerArray[index] = lastobj;
                    this.showtextbox=false;
          }else{
            console.error('Failed to fetch data');
          }
        },
        error: (error) => {
          const index = this.AnswerArray.length - 1;
          console.error('API Error:', error);
          // this.messageService.add({
          //   severity: 'error',
          //   detail: error.error.ex_error_description,
          // });
          if(error.error.error=='1'){
            lastobj.question=trimmedQuery;
            lastobj.isLoading = false;
           lastobj.sqlDescription = error.error.ex_error_description;
          lastobj.displayedColumns = [];
           lastobj.tableData = [];
          lastobj.row_count = 0;
          lastobj.pagination.totalPages =0
          lastobj.pagination.currentPage = 1;
           this.AnswerArray[index] = lastobj;     
          }
          this.showtextbox=false;
        },
      });
    
      this.query = '';
      this.inputHeight=40
    }
          onTabClick(conversation: any, tab: string) {
        conversation.activeTab = tab;
        if(conversation.chart_data){
          conversation.chartData = this.sanitizeChartData(conversation.chart_data);
          conversation.hasValidChart=true;
        }    
        else if (tab === 'chart' && !conversation.chartFetched && !conversation.chartLoading && !conversation.chartData) {
          conversation.chartLoading = true;
          this.fetchVisualizationData(conversation);
        }

        if(conversation.analysis){
          conversation.smartAnalysis= conversation.analysis;
          conversation.hasAnalysis=true;
        }

        else if (tab === 'smart' && !conversation.analysisFetched && !conversation.analysisLoading && !conversation.analysis) {
          conversation.analysisLoading = true;
          this.fetchSmartAnalysis(conversation);
        }
      }

    changeCurrentPage(index: number, direction: 'prev' | 'next') {
      const answer = this.AnswerArray[index];
      if (direction == 'prev' && answer.pagination.currentPage > 1) {
        answer.pagination.currentPage--;
      } else if (direction =='next' && answer.pagination.currentPage < answer.pagination.totalPages) {
        answer.pagination.currentPage++;
      }
    }
    openSQLmodal(conversation:any){
      if (conversation.displaySQLmodal) {
        conversation.displaySQLmodal = false;
      } else {
        this.prevConvesations.forEach((conv) => 
          conv.displaySQLmodal = false
          
        );
        this.sqlFormatter= format(conversation.response_sql, { language: 'mysql', tabWidth: 2, keywordCase: 'upper', linesBetweenQueries: 2 })        
        conversation.displaySQLmodal = true;
    }
    }
  
    downloadTableData(conversation: any,dataset_name:any|''): void {
      if (!conversation?.tableData || !conversation?.displayedColumns) {
        console.error('Invalid or incomplete conversation data.');
        return;
      }
    
      // Map tableData and displayedColumns to headers and parsedData
      conversation.headers = conversation.displayedColumns;
      conversation.parsedData = conversation.tableData.map((row: any) =>
        conversation.displayedColumns.map((header: string) => row[header] ?? '')
      );
    
      this.downloadprevAnswer(conversation,dataset_name);
    }
    paginatedTableData(answer: any) {
      const startIndex = (answer.pagination.currentPage - 1) * answer.pagination.itemsPerPage;
      const endIndex = startIndex + answer.pagination.itemsPerPage;
      return answer.tableData.slice(startIndex, endIndex);
    }
    loadTableschema(conversation_Id:any){
      this.loader=true;
      let payload={
        "conversation_id": conversation_Id
    };
      this.api.putpMethod("tableSchemaByConversationID",payload).subscribe({
        next:(data:any)=>{ 
           this.tableSchema= data.table_name_n_table_schema_dict;
           this.getConversationById(this.selectedConversationId);
        },
        
        error: (error) => {
          this.loader=false;
          console.error('API Error:', error);
          this.messageService.add({ severity: 'error', detail: error.error.ex_error_description });
        }
    })
  }
  deleteConv(conv:any){
    this.Delete_payload=conv;
    this.displayDeletemodal=true;
    this.deleteMessage=`Do you want to delete the ${conv.conv_name} conversation`;
     
    }
    ConfirmDelete(){
      let body={
        "conversation_id":this.Delete_payload.conversation_id
    }
      this.api.deletepMethod('deleteConversation',body).subscribe({
        next:(res)=>{  
          this.messageService.add({ severity: 'success', detail: res.ex_error_description });     
         this.getAllConversations();  
         this.displayDeletemodal=false;       
          },
          error:(error) => {
            console.error('API Error:', error);
            this.messageService.add({ severity: 'error', detail: error.error.ex_error_description});}
    })
    }
    CancelDel(){
      this.displayDeletemodal=false
    }
}
  
